import { Link, useParams } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import NewsCard from '@/components/feature/NewsCard';
import { newsList } from '@/mocks/news';

export default function NewsDetail() {
  const { id } = useParams<{ id: string }>();
  const item = newsList.find((n) => n.id === id);

  if (!item) {
    return (
      <div className="min-h-screen flex flex-col bg-background-50">
        <Navbar />
        <div className="h-16 md:h-[72px]" />
        <main className="flex-1 flex items-center justify-center px-4 py-24">
          <div className="text-center max-w-md">
            <span className="w-20 h-20 rounded-full bg-background-200 flex items-center justify-center text-foreground-400 mx-auto mb-6">
              <i className="ri-article-line text-4xl"></i>
            </span>
            <h1 className="font-heading font-bold text-2xl text-foreground-950">资讯未找到</h1>
            <p className="text-sm text-foreground-500 mt-3 leading-relaxed">
              抱歉，你访问的资讯不存在或已被移除，请返回资讯列表查看其他内容。
            </p>
            <div className="flex items-center justify-center flex-wrap gap-3 mt-8">
              <Link
                to="/news"
                className="px-5 py-2.5 rounded-md bg-primary-500 text-white text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap"
              >
                <i className="ri-arrow-left-line mr-1.5"></i> 返回资讯列表
              </Link>
              <Link
                to="/"
                className="px-5 py-2.5 rounded-md bg-background-100 border border-background-300 text-foreground-800 text-sm font-semibold hover:bg-background-200 transition-colors whitespace-nowrap"
              >
                返回首页
              </Link>
            </div>
          </div>
        </main>
        <Footer />
      </div>
    );
  }

  const related = newsList.filter((n) => n.id !== item.id).slice(0, 3);

  return (
    <div className="min-h-screen flex flex-col bg-background-50">
      <Navbar />
      <div className="h-16 md:h-[72px]" />

      <main className="flex-1">
        <div className="w-full px-4 md:px-8 py-6 md:py-10">
          <Breadcrumb items={[{ label: '影视资讯', to: '/news' }, { label: item.title }]} />

          <article className="mt-6 max-w-3xl">
            <span className="inline-block px-2.5 py-1 rounded-md text-xs font-medium bg-accent-500 text-white">
              {item.tag}
            </span>
            <h1 className="font-heading font-extrabold text-2xl md:text-3xl lg:text-4xl text-foreground-950 mt-4 leading-snug">
              {item.title}
            </h1>
            <div className="flex items-center flex-wrap gap-3 mt-4 text-sm text-foreground-500">
              <span className="flex items-center gap-1.5">
                <i className="ri-calendar-line"></i> {item.date}
              </span>
              <span className="w-px h-4 bg-background-300"></span>
              <span className="flex items-center gap-1.5">
                <i className="ri-admin-line"></i> 影视资讯编辑组
              </span>
            </div>
          </article>

          <div className="mt-8 w-full max-w-4xl aspect-[16/9] rounded-lg overflow-hidden bg-background-200 border border-background-200/70">
            <img
              src={item.cover}
              alt={`${item.title} 配图`}
              title={`${item.title} 影视资讯`}
              className="w-full h-full object-cover"
            />
          </div>

          <div className="mt-8 max-w-3xl space-y-5 text-foreground-700 leading-loose text-sm md:text-base">
            <p className="text-foreground-900 font-medium text-base md:text-lg leading-relaxed">
              {item.summary}
            </p>
            {item.content.map((p, i) => (
              <p key={i}>{p}</p>
            ))}
          </div>

          <div className="mt-10 max-w-3xl flex items-center justify-between flex-wrap gap-4 pt-6 border-t border-background-200">
            <Link
              to="/news"
              className="flex items-center gap-1.5 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap"
            >
              <i className="ri-arrow-left-line"></i> 返回资讯列表
            </Link>
            <div className="flex items-center gap-2 text-sm text-foreground-500">
              <span>分享：</span>
              <span className="w-8 h-8 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
                <i className="ri-wechat-line"></i>
              </span>
              <span className="w-8 h-8 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
                <i className="ri-weibo-line"></i>
              </span>
              <span className="w-8 h-8 rounded-md bg-secondary-100 text-secondary-900 flex items-center justify-center">
                <i className="ri-link"></i>
              </span>
            </div>
          </div>

          <section className="mt-14 md:mt-20">
            <h2 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-6">相关资讯推荐</h2>
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-6">
              {related.map((n) => (
                <NewsCard key={n.id} item={n} layout="grid" />
              ))}
            </div>
          </section>
        </div>
      </main>

      <Footer />
    </div>
  );
}